interface SzTypes {
    id: number;
    name: string
}

let list = [
    {
        id: 0,
        name: "收款"
    },
    {
        id: 1,
        name: "借款"
    },
    {
        id: 2,
        name: "收到投资款"
    },
    {
        id: 3,
        name: "手续费"
    },
    {
        id: 4,
        name: "付款"
    },
    {
        id: 5,
        name: "上缴社保"
    },
    {
        id: 6,
        name: "上缴增值税"
    },
    {
        id: 7,
        name: "利息费用"
    },
    {
        id: 8,
        name: "其他"
    },
    {
        id: 9,
        name: "其他收款"
    },
    {
        id: 10,
        name: "支付工资"
    },
    {
        id: 11,
        name: "上缴公积金"
    },
    {
        id: 12,
        name: "税控盘"
    },
    {
        id: 13,
        name: "上缴印花税"
    },
    {
        id: 14,
        name: "上缴城市维护建设税"
    },
    {
        id: 15,
        name: "上缴教育费附加"
    },
    {
        id: 16,
        name: "上缴地方教育费附加"
    },
    {
        id: 17,
        name: "上缴个人所得税"
    },
    {
        id: 18,
        name: "上缴企业所得税"
    },
    {
        id: 19,
        name: "上缴房产税"
    },
    {
        id: 20,
        name: " 支付运输费"
    },
    {
        id: 21,
        name: "支付办公费"
    },
    {
        id: 22,
        name: "向银行贷款"
    },
    {
        id: 23,
        name: "还银行贷款"
    },

]

let SzTypes = {
    list: list,
}
export default SzTypes